import { render, staticRenderFns } from "./AccountRecharge.vue?vue&type=template&id=bf00bea6&scoped=true"
import script from "./AccountRecharge.vue?vue&type=script&lang=js"
export * from "./AccountRecharge.vue?vue&type=script&lang=js"
import style0 from "./AccountRecharge.vue?vue&type=style&index=0&id=bf00bea6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf00bea6",
  null
  
)

export default component.exports